const Feels = (): JSX.Element => (
  <svg
    width="15"
    height="15"
    viewBox="0 0 40 100"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.5 13.3925C7.5 5.995 13.0975 0 20 0C26.9025 0 32.5 5.995 32.5 13.3925V64.3875C35.7346 66.9773 38.085 70.5078 39.2264 74.4912C40.3677 78.4745 40.2436 82.714 38.8713 86.6238C37.4989 90.5336 34.9461 93.9206 31.5655 96.3168C28.185 98.713 24.1436 100 20 100C15.8564 100 11.815 98.713 8.43446 96.3168C5.05391 93.9206 2.50107 90.5336 1.12873 86.6238C-0.24361 82.714 -0.367686 78.4745 0.773647 74.4912C1.91498 70.5078 4.26537 66.9773 7.5 64.3875V13.3925ZM17.4594 43.5536C20.4484 44.3284 23.8593 45.2125 27.5 45.1525V39.94V29.94V19.94V13.3925C27.5 8.955 24.1425 5.3575 20 5.3575C15.8575 5.3575 12.5 8.955 12.5 13.3925V42.4975C13.965 42.6475 15.63 43.0775 17.455 43.5525L17.4594 43.5536Z"
    />
  </svg>
)

export default Feels
